import CustomLottie from ".//custom-lottie";

export default CustomLottie;
